import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interaction-card',
  templateUrl: './interaction-card.component.html',
  styleUrls: ['./interaction-card.component.css']
})
export class InteractionCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
